import styled from 'styled-components';
import { BadgedAvatarMixin } from '../../mixins/components/BadgedAvatarMixin';
export var StyledBadgedAvatar = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledBadgedAvatar",
  componentId: "c11n-8-111-1__sc-1d1a27i-0"
})(["", ""], BadgedAvatarMixin);